import * as React from 'react';

import { FundHero } from '@/components/engagement/fund-hero';
import { FundModel } from '@/components/engagement/fund-model';
import { FundTrust } from '@/components/engagement/fund-trust';
import { PathwayCards } from '@/components/engagement/pathway-cards';
import { InterestForm } from '@/components/engagement/interest-form';
import { fundPage, pathways } from '@/content/engagement';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

/**
 * `/the-fund` — donor-funded model, Tour De Cure governance, pathways.
 */
export function TheFundPage() {
  React.useEffect(() => {
    const previous = document.title;
    document.title = fundPage.documentTitle;
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <article className="flex flex-col">
      <FundHero />
      <FundModel />
      <FundTrust />

      <PathwayCards
        pathways={[...pathways]}
        headingId="fund-pathways-heading"
        heading="Three ways to give and commit"
      />

      <section
        id="register"
        aria-labelledby="fund-register-heading"
        className="scroll-mt-24 px-4 pb-16 sm:px-6 sm:pb-20 lg:px-8"
      >
        <div className="mx-auto grid w-full max-w-7xl gap-10 lg:grid-cols-[minmax(0,0.95fr)_minmax(0,1.05fr)] lg:items-start">
          <div>
            <p className="text-primary mb-3 text-xs font-medium tracking-[0.2em] uppercase">
              Next step
            </p>
            <h2
              id="fund-register-heading"
              className="font-display text-foreground text-2xl font-semibold tracking-tight sm:text-3xl"
            >
              Ready to give or start a multi-year commitment?
            </h2>
            <p className="text-muted-foreground mt-4 max-w-xl text-base leading-relaxed sm:text-lg">
              Donation gifts go through Tour De Cure’s established giving channel. Multi-year giving and
              advocacy interest can be registered here so the team can follow up.
            </p>
            <div className="mt-6">
              <Button asChild variant="outline">
                <Link to="/get-involved">Open Get Involved</Link>
              </Button>
            </div>
          </div>
          <InterestForm
            idPrefix="fund"
            defaultInterest="partner"
            heading="Register interest"
            description="Individual, corporate, and philanthropic giving enquiries come here first — no minimum, no gatekeeping."
          />
        </div>
      </section>
    </article>
  );
}
